import React from 'react';
import FormErrors from '../components/FormErrors';
import {Modal, Button, ModalHeader} from 'react-bootstrap';
import LoadingComponent from '../components/LoadingComponent';
import SavingComponent from '../components/SavingComponent';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import {FormattedMessage} from 'react-intl';
import Messages from '../messages';
import {MdAdd, MdAttachFile, MdEdit, MdCheckBox, MdCheckBoxOutlineBlank, MdCloudDownload, MdCloudUpload, MdSave} from 'react-icons/lib/md';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import PDFViewer from '../containers/PdfViewer';
import {blobToDataURL} from 'blob-util';
import Toggle from 'react-toggle';


import 'jspdf-autotable';
import {PDFDocument, TextAlignment} from "@cantoo/pdf-lib";
import Footer from '../components/Footer';
import OidcProvider from '../services/OidcProvider';
import NavBar from '../components/NavBar';
import {ApiService} from '../services/ApiService';
import {newlineChars} from '@cantoo/pdf-lib';
import {DocumentEditField} from "../components/documents/DocumentEditField";
import {DocumentManagementModal} from "../components/documents/DocumentManagementModal";

const globalMessages = Messages;
const apiFlagREADY_FOR_UPLOAD = 'READY_FOR_UPLOAD';
const apiFlagFINISHED_PROCESSING = 'FINISHED_PROCESSING';
const apiFlagERROR_PROCESSING = 'ERROR_PROCESSING';
const apiFlagASSIGN_UPLOAD_COMPLETE = 'Upload complete';
const MAX_TIME_WAITED = 30000;
const MAX_PROFILE_NAME_LENGTH = 40;
const NO_PROFILE_FLAG = 'NO_PROFILE';

import DocumentService from "../services/DocumentService";

//The API service is a self-contained static provider to talk to the certblock api
const documentService = new DocumentService();


const certblockAPI = new ApiService();

export class SearchContainer extends React.Component {

	constructor(props) {

		super(props);

		this.apiConfig = window.ApiConfig;
		this.deliveryNumberInput = React.createRef();
		console.log('SearchContainer');
		this.state = {
			isSiemensOrSupplier: true,
			certificateId: '',
			supplier: '',
			orderNumber: '',
			deliveryNumber: '',
			orderPosition: '',
			materialNumber: '',
			materialDescription: '',
			quantity: '',
			serialNumber: '',
			overviewTests: '',
			nameInspector: '',
			inspectionDate: moment(),
			confirmationText: '',
			confirmation: '',
			checkTestsResults: '',
			certificateList: [],
			supplierData: {
				name: '', street: '', zip: '', city: '', country: ''
			},
			consigneeIndex: null,
			consigneeData: {
				name: '', street: '', zip: '', city: '', country: ''
			},
			showLoadingModal: false,
			showSavingModal: false,
			formErrors: {
				supplier: '',
				orderNumber: '',
				deliveryNoteNumber: '',
				deliveryNumber: '',
				orderPosition: '',
				materialNumber: '',
				materialDescription: '',
				quantity: '',
				serialNumber: '',
				overviewTests: '',
				nameInspector: '',
				inspectionDate: '',
				confirmationText: '',
				confirmation: ''
			},
			deliveryNoteNumber: '',
			deliveryNoteNumbers: [],
			orderNumbersForSupplier: [],
			materials: [],
			documentProfiles: {},
			supplierNumber: '',
			isLoadingPrefix: false,
			isSupplier: false,
			apiErrorMessage: '',
			apiErrorMessageForDevelopers: '',
			checkBoxList: undefined,
			noApiCallResultMessage: false,
			addedSerialNumbersDict: {},
			withoutSNdict: {}, //used to store files in case of no SN added
			useSerialNumbers: false,
			newDNN: {},
			// orderNumber typeahead options
			orderNumberSearchOptions: [],

			// orderPosition table ("Materials Order Details")
			orderPositions: [],

			// state to control the download/edit modal dialog
			showAddSerialNumbersModal: false,
			serialNumbersModalData: {
				orderNumber: "", deliveryNoteNumber: "", orderPosition: {
					id: "", name: ""
				}
			}
		};

	}

	setSupplierNumber() {
		const IAM_API = certblockAPI.getIAM_API(this.getUser().id_token);
		IAM_API.userCurrent()
			.then((certblockUser) => {
				this.setState({
					// testerList: certblockUser.data.testers ? certblockUser.data.testers : [],
					// tests: certblockUser.data.materialTests ? certblockUser.data.materialTests : [],
					supplierNumber: certblockUser.data.supplier ? certblockUser.data.supplier : ''
				});
			}).catch((error) => {
			this.setState({
				showAPIErrorModal: true, apiErrorMessage: globalMessages[localStorage.getItem('language')].createCertificate.uiErrorMessageFailAPICall, apiErrorMessageForDevelopers: JSON.stringify(error)
			});
		});

	}

	componentDidMount() {

		this.getRole();
		this.setSupplierNumber();
		// console.log(`DEBUG [componentDidMount] this.state.serialNumber: ${this.state.serialNumber}`);
	}


	getRole = () => {
		console.log(`Debug[getRole]`);
		const oidc = new OidcProvider();
		const user = oidc.getUser();

		// console.log(user);

		if (user.role === 'userSupplier') {
			this.setState({isSupplier: true}, () => {
				// console.log(`Debug[getRole] isSupplier: ${this.state.isSupplier}`);
			});
			//MARWAL @TODO MOCK change to Siemens => works with tkn out => to be tested
			// this.setState({ isSupplier: false },()=>{
			//     console.log(`Debug[getRole] isSupplier: ${this.state.isSupplier}`);
			// });
		}
	}

	getUser = () => {
		return JSON.parse(localStorage.getItem('oidc_user'));
	};

	errorClass = (error) => {
		return (error.length === 0 ? '' : 'is-invalid');
	};


	/// Order number query and management
	async getOrderNumbersPrefix(orderNumberPrefix) {
		console.log(`DEBUG[getOrderNumbersPrefix] prefix: ${orderNumberPrefix}`);
		try {
			let orderNumberSearchOptions = (await certblockAPI.callApi('orderList', [orderNumberPrefix])).data;
			this.setState({orderNumberSearchOptions}, () => this.setState({isLoadingPrefix: false}))
		} catch (error) {
			console.log('MARWAL DEBUG[getOrderNumbersPrefix] Error:');
			console.log(error);
			this.setState({isLoadingPrefix: false});
			this.setState({
				showAPIErrorModal: true,
				showLoadingModal: false,
				showSavingModal: false,
				apiErrorMessage: globalMessages[localStorage.getItem('language')].searchDocuments.apiErrorMessageGetOrderNumberPrefix,
				apiErrorMessageForDevelopers: JSON.stringify(error)
			});
		}
		return [];
	}

	// Normalizes the react-bootstrap-typeahead onChange payload (an array of
	// selections, each either a plain string option or a custom-option object)
	// into a plain order number string.
	extractOrderNumber(selection) {
		let value = Array.isArray(selection) ? selection[0] : selection;
		if (value && typeof value === 'object') {
			value = value.label ?? value.id ?? '';
		}
		return (value ?? '').toString().trim();
	}

	async handleChangeOrderNumber(selection) {
		console.log(`DEBUG  [handleChangeOrderNumber] value: ${selection}`);
		let orderNumber = this.extractOrderNumber(selection);
		this.setState({orderNumber});
		if (orderNumber.length >= 10) {
			await this.loadOrderDocuments(orderNumber);
		}
	}

	// Loads the delivery notes (and thereby the uploaded documents) for a full
	// order number. This is driven purely by the uploaded-document store, so it
	// works even when the order is no longer present in the SAP order mirror and
	// was therefore not offered by the autocomplete.
	async loadOrderDocuments(orderNumber) {
		await this.getDeliveryNotes(orderNumber, (returnedDeliveryNotes) => {
			console.log(`returnedDeliveryNotes number: ${returnedDeliveryNotes.length}`);
			console.log(returnedDeliveryNotes);
			this.setState({
				deliveryNoteNumbers: returnedDeliveryNotes, orderNumber: orderNumber, materials: [], noApiCallResultMessage: false, checkBoxList: new Array(returnedDeliveryNotes.length).fill(false)
			});
			if (returnedDeliveryNotes.length === 0) {
				this.setState({
					noApiCallResultMessage: true
				});
			}
		});
	}

	// Commits a manually typed order number that was not chosen from the
	// autocomplete list. Fires when the user presses Enter or leaves the field,
	// but only for a full (>= 10 digit) numeric SAP order number, so authorized
	// users can reach documents of orders missing from the autocomplete.
	commitTypedOrderNumber = async (event) => {
		let typed = (event?.target?.value ?? '').toString().trim();
		if (!/^\d{10,}$/.test(typed)) {
			return;
		}
		if (typed === this.state.orderNumber) {
			return;
		}
		this.setState({orderNumber: typed});
		await this.loadOrderDocuments(typed);
	}

	handleOrderNumberKeyDown = async (event) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			await this.commitTypedOrderNumber(event);
		}
	}

	handleCheckBoxClicked = async (idx, orderNumber, deliveryNoteNumber) => {
		this.setState({
			orderPositions: []
		});
		console.log(`DEBUG  [handleCheckBoxClicked] idx: ${idx} orderNumer:${orderNumber} deliveryNoteNumber:${deliveryNoteNumber} clicked`);
		let newCheckedArray = this.state.checkBoxList;
		newCheckedArray = newCheckedArray.map((el, id) => {
			return id == idx
		});
		this.setState({
			checkBoxList: newCheckedArray,
			deliveryNoteNumber: deliveryNoteNumber
		});
		return this.buildMaterialTable(orderNumber, deliveryNoteNumber);
	}

	async buildMaterialTable(orderNumber, deliveryNoteNumber) {
		// fetch orderdata, if possible
		let orderMaterial = [];
		try {
			let orderDataResponse = await certblockAPI.callApi(
				'materials',
				[orderNumber],
				'get'
			);
			orderMaterial = orderDataResponse.data;
		} catch (e) {
			console.log("no material entry");
		}

		let orderPositionsWithDocuments = await documentService.getOrderPositionsWithDocumentsOfDeliveryNote({orderNumber, deliveryNoteNumber});
		let filteredOrderPositions = orderMaterial.filter(orderPosition => orderPositionsWithDocuments.indexOf(orderPosition['EBELP']) > -1);

		console.log(filteredOrderPositions);
		console.log(orderPositionsWithDocuments);
		//all order positions, that are not present in the material list, need to have an empty set of data
		let emptyOrderPositions = orderPositionsWithDocuments.filter(o => !filteredOrderPositions.find(op => op['EBELP'] === o)).map(o => ({
			"EBELN": this.state.orderNumber,
			"EBELP": o,
			"EMATN": "",
			"TXZ01": "",
			"BSTMG": 0,
			"BSTME": "",
			"LIFNR": "",
			"PRFZG": "",
			"SSQSS": "",
			"ZGTYP": "",
			"TP_DPROF": "",
			"ZZ_KM_IND": "",
			"SERNP": "",
			"WERKS": "",
			"SERNP_FLAG": "",
			"SERIAL_ENABLED": false
		}));
		console.log("empty order positions:", emptyOrderPositions);
		filteredOrderPositions.push(...emptyOrderPositions);
		console.log("filtered order positions", filteredOrderPositions);


		this.setState({
			orderPositions: filteredOrderPositions
		});
	}

	async getDeliveryNotes(orderNumber, callback) {
		console.log('DEBUG [getDeliveryNotes]');
		try {
			let response = await certblockAPI.getDeliveryNotes(orderNumber, callback);
			return response;
		} catch (error) {
			console.log('Error: ' + JSON.stringify(error));
			this.setState({
				showAPIErrorModal: true,
				showLoadingModal: false,
				showSavingModal: false,
				apiErrorMessage: globalMessages[localStorage.getItem('language')].searchDocuments.apiErrorMessageGetDeliveryNotes,
				apiErrorMessageForDevelopers: JSON.stringify(error)
			});
		}
	}

	editDNNButtonClicked(DNN) {
		console.log(`DEBUG [editDNNButtonClicked] ${this.state.orderNumber} ${DNN}`);
		let newDNNs = this.state.newDNN;
		newDNNs[DNN] = (!newDNNs[DNN] || newDNNs[DNN] == undefined)? DNN : undefined;
		this.setState({
			newDNN: newDNNs
		},()=>{console.log(this.state.newDNN)});
	}

	edited(DNN) {
		return (this.state.newDNN[DNN] != undefined);
	}

	async saveDNN(DNN, idx) {
		console.log(`DEBUG [saveDNN] ${this.state.orderNumber} ${DNN} newDNN: ${this.state.newDNN[DNN]} DNN idx: ${idx}`);
		let deliveryNoteNumbersNew = this.state.deliveryNoteNumbers;
		let newDNNs = this.state.newDNN;
		try {
                    this.setState({
                        showSavingModal: true
                    })
                    await certblockAPI.changeDNN(this.state.orderNumber,DNN,this.state.newDNN[DNN],(result)=>{
                        if(result) {
							// console.log(result);  //    message: "sucess"
                            // console.log('success');
							deliveryNoteNumbersNew[idx].deliveryNoteNumber = this.state.newDNN[DNN];
							newDNNs[DNN] = undefined;
                        }
                    })
			} catch (error){
				console.log('DEBUG[editButtonClicked] error:');
				console.log(error);
		}
		this.setState({
			showSavingModal: false,
			newDNN: newDNNs,
			deliveryNoteNumbers: deliveryNoteNumbersNew
		});
		
	}

	handleChangeDNN(event, DNN) {
		let value;
		value = event.target.value;
		// console.log(`value: ${value} DNN: ${DNN}`);
		let newDNNs = this.state.newDNN;
		newDNNs[DNN] = value;
		this.setState({
			newDNN: newDNNs
		});
	}

	openDownloadModal = async (order, material, serialNumberEnabled) => {
		console.log("DEBUG:::: opendownloadmoadl");
		this.setState({
			showAddSerialNumbersModal: true
		})
		this.setState({
			serialNumbersModalData: {
				orderNumber: this.state.orderNumber,
				deliveryNoteNumber: this.state.deliveryNoteNumber,
				orderPosition: {
					id: material['EBELP'],
					name: material['TXZ01']
				},
				enableSerialNumberManagement: serialNumberEnabled
			}
		});
	}

	cancelDownloadEdit = () => {
		console.log(`DEBUG[cancelDownloadEdit]`);
		this.setState({
			showAddSerialNumbersModal: false
		})
	}

//--------------------------------
	render = () => {
		return (<div>
			<DocumentManagementModal show={this.state.showAddSerialNumbersModal}
									 orderNumber={this.state.serialNumbersModalData.orderNumber}
									 deliveryNoteNumber={this.state.serialNumbersModalData.deliveryNoteNumber}
									 orderPosition={this.state.serialNumbersModalData.orderPosition}
									 key={`${this.state.showAddSerialNumbersModal}`}
									 enableSerialNumberManagement={this.state.serialNumbersModalData.enableSerialNumberManagement}
									 closeContainerCallback={() => this.cancelDownloadEdit()}
									 enableUpload={this.state.isSupplier}
			/>
			<NavBar/>
			<FormErrors formErrors={this.state.formErrors}/>
			{this.state.isSiemensOrSupplier && <div className="container col-xl-6 col-lg-9 col-md-12 col-sm-12">
				<h2><FormattedMessage id="searchDocuments.formTitle"/></h2>

				<div className="card" style={{padding: 20, marginTop: 30}}>
					<div className="form-row">
						<div className="form-group col-md-12 col-sm-12">
							<label htmlFor="orderNumberInput"><FormattedMessage id="searchDocuments.formOrderNumber"/></label>
							<AsyncTypeahead
								onChange={async (orderNumber) => this.handleChangeOrderNumber(orderNumber)}
								id="orderNumberInput"
								value={this.state.orderNumber}
								isLoading={this.state.isLoadingPrefixes}
								inputProps={{
									className: `form-control ${this.errorClass(this.state.formErrors.orderNumber)}`,
									onKeyDown: this.handleOrderNumberKeyDown,
									onBlur: this.commitTypedOrderNumber
								}}
								placeholder={globalMessages[localStorage.getItem('language')].createCertificate.formOrderNumberPlaceHolder}
								options={this.state.orderNumberSearchOptions}
								onSearch={async (prefix) => this.getOrderNumbersPrefix(prefix)}/>
							<label hidden={!this.state.noApiCallResultMessage}>{globalMessages[localStorage.getItem('language')].searchDocuments.noApiCallResultMessage}</label>
						</div>
					</div>
				</div>

				<div className="card" style={{padding: 20, marginTop: 30}}>
					<div id="normalMode">
						<label htmlFor="orderNumberInput">
							<FormattedMessage
								id="searchDocuments.formOrderAndDeliverTable"
								values={{order: this.state.orderNumber}}
							/>
						</label>
						<table className="table">
							<tbody>
							{this.state.deliveryNoteNumbers.map((deliveryNoteNumbers, index) => {
								return (<tr key={deliveryNoteNumbers.deliveryNoteNumber}>
									<td style={{width: '8px'}}>
										<input type='radio'
											   id={deliveryNoteNumbers.deliveryNoteNumber + '_radio'}
											   value={deliveryNoteNumbers.deliveryNoteNumber}
											   onClick={() => this.handleCheckBoxClicked(index, this.state.orderNumber, deliveryNoteNumbers.deliveryNoteNumber)}
											   checked={this.state.checkBoxList[index]}
											   onChange={()=>{}}
										/>										
									</td>
									<td>
										<form>
											<FormattedMessage id="searchDocuments.tableDeliveryNoteTitle"/>
											<input 
												type='text' 
												disabled={true} 
												value={deliveryNoteNumbers.deliveryNoteNumber}
												style={{ width: `${deliveryNoteNumbers.deliveryNoteNumber.toString().length+2}ch`, maxWidth: '80%'}} 
												hidden={this.edited(deliveryNoteNumbers.deliveryNoteNumber)}
											/>
											<input name='newDeliveryNoteNumber'
												type='text' 
												disabled={false} 
												contentEditable={true}
												value={this.state.newDNN[deliveryNoteNumbers.deliveryNoteNumber]}
												onChange={(e)=>this.handleChangeDNN(e,deliveryNoteNumbers.deliveryNoteNumber)}                                                                
												style={{ width: `${deliveryNoteNumbers.deliveryNoteNumber.toString().length+2}ch`, maxWidth: '80%'}} 
												hidden={!this.edited(deliveryNoteNumbers.deliveryNoteNumber)}
											/>
											<button type="button"  
													className={true? 
														"btn btn-info btnDeleteMaterial" :
														"btn btn-warning btnDeleteMaterial"
													} 
													hidden={!this.state.isSupplier}
													disabled={false} style={{ padding: 2 }} 
													value={index} 
													onClick={()=>{
														this.editDNNButtonClicked(deliveryNoteNumbers.deliveryNoteNumber);
													}} 
													id={'editButton' + deliveryNoteNumbers.deliveryNoteNumber} >
														<MdEdit size={15} />
											</button>
											{' '}
											<button type="button"  
												className={true? 
													"btn btn-info btnDeleteMaterial" :
													"btn btn-warning btnDeleteMaterial"
												} 
												hidden={!this.state.isSupplier || !this.edited(deliveryNoteNumbers.deliveryNoteNumber)}
												disabled={false} style={{ padding: 2 }} 
												value={index} 
												onClick={()=>{
													this.saveDNN(deliveryNoteNumbers.deliveryNoteNumber, index);
												}} 
												id={'saveButton' + deliveryNoteNumbers.deliveryNoteNumber} >
													<MdSave size={15} />
											</button>
										</form>
									</td>
								</tr>)

							})}
							</tbody>
						</table>
					</div>
				</div>
				<div className="card" style={{padding: 20, marginTop: 30}}>
					<div id="normalMode">
						<label htmlFor="orderNumberInput"><FormattedMessage id="createCertificate.formMaterialFromOrderNum"/></label>
						<table className="table">
							<thead>
							<tr>
								<th scope="col"><FormattedMessage id="searchDocuments.formOrderPosition"/></th>
								<th scope="col"><FormattedMessage id="searchDocuments.formQuantity"/></th>
								<th scope="col"><FormattedMessage id="searchDocuments.formMaterialNumber"/></th>
								<th scope="col"><FormattedMessage id="searchDocuments.formMaterialDesc"/></th>
								<th scope="col"><FormattedMessage id="searchDocuments.formAction"/></th>
								<th scope="col"/>
							</tr>
							</thead>
							<tbody>
							{
								this.state.orderPositions.map(orderPosition => (
									<tr key={`materialTable-${this.state.orderNumber}-${orderPosition['EBELP']}-${orderPosition['SERIAL_ENABLED']}`}>
										<td>{orderPosition['EBELP']}</td>
										<td>{orderPosition['BSTMG']}</td>
										<td>{orderPosition['EMATN']}</td>
										<td>{orderPosition['TXZ01']}</td>
										<td>
											<Button onClick={() => this.openDownloadModal(this.state.orderNumber, orderPosition, orderPosition['SERIAL_ENABLED'])}>
												<MdCloudUpload size={15}/>&nbsp;&nbsp;
												<FormattedMessage id="searchDocuments.formDowloadEditButton"/>
											</Button>
										</td>
									</tr>
								))
							}
							</tbody>
						</table>
					</div>
				</div>
			</div>}
			<br/>
			<div className='container'>
			</div>
			<div>
				<LoadingComponent hidden={this.state.showLoadingModal}/>
			</div>
			<div>
				<SavingComponent hidden={this.state.showSavingModal}/>
			</div>
			<div>
				<Modal animation={false} show={this.state.showAPIErrorModal}>
					<ModalHeader>
						<Modal.Title><FormattedMessage id="uploadDocuments.uiErrorMessageFailTitleAPICall"/></Modal.Title>
					</ModalHeader>
					<Modal.Body>
						<div>{this.state.apiErrorMessage}</div>
						<div>{this.state.apiErrorMessageForDevelopers}</div>
					</Modal.Body>
					<Modal.Footer>
						<Button
							onClick={() => {
								this.setState({showAPIErrorModal: false})
							}}><FormattedMessage id="uploadDocuments.closeButton"/></Button>
					</Modal.Footer>
				</Modal>
			</div>
			<Footer/>
		</div>);
	}
}

export default SearchContainer
